import React, { FunctionComponent } from 'react';
import '../../../styles/news-forge.styles.scss';
import { DATA_QA } from '../../../helpers/data-qa';

export type ButtonProps = {
	text: string;
	title?: string;
	maxWidth?: string;
	onClickAction: (event: React.MouseEvent) => void;
};

export const ClearButton: FunctionComponent<ButtonProps> = ({ text, title, maxWidth, onClickAction }) => {
	return (
		<div data-qa={DATA_QA.NEWS_FORGE_EXTRACT_AND_CLEAR_BUTTON} className='clear-button-container'>
			<div className='clear-button' title={title} style={{ maxWidth: maxWidth || 'auto' }} onClick={(e) => onClickAction(e)}>
				<span className='button-label'>{text}</span>
			</div>
		</div>
	);
};

export default ClearButton;
